(function Navbar() {
  let $accountDropdown = $('#accountDropdown'); // Drodpown for account menu.
  let $productTypeLinks = $('.product-types-link'); // Links to main product categories.

  // Redirect to account profile if account icon is clicked on (menu is toggled on account icon hover).
  $accountDropdown.on(
    'click',
    (e) => (window.location = $(e.currentTarget).attr('href'))
  );

  // Toggle account menu if account icon is touched (hover is not possible on touch devices).
  $accountDropdown.on('touchstart', (e) => {
    e.preventDefault();

    $accountDropdown.dropdown('toggle');
  });

  // Redirect to provided link if product type link is clicked on (menu is toggled on hover).
  $productTypeLinks.on('click auxclick', (e) => {
    if (e.type == 'auxclick' && e.which != 2) {
      // non-primary button e.g. prev/next
      return;
    }
    e.stopPropagation();

    let redirectTo = $(e.currentTarget).data('redirectLink');

    if (redirectTo) {
      const inNewTab = e.ctrlKey || e.metaKey || e.which == 2; // middle click
      if (inNewTab) {
        window.open(redirectTo, '_blank');
      } else {
        window.location.href = redirectTo;
      }
    }
  });

  // Toggle account menu if product type link is touched (hover is not possible on touch devices).
  $productTypeLinks.on('touchstart', (e) => {
    e.preventDefault();

    let redirectTo = $(e.currentTarget).data('redirectLink');

    // Check if menu is a hamburger menu. Redirect to the provided link if menu is in hamburger mode.
    if (window.outerWidth > 892) {
      $(e.target).dropdown('toggle');
    } else if (redirectTo) {
      window.location = redirectTo;
    }
  });

  // Toggle account menu if product type link is touched (hover is not possible on touch devices).
  $productTypeLinks.on('keydown', (e) => {
    if (e.key == 'Enter') {
      let redirectTo = $(e.currentTarget).data('redirectLink');
      if (redirectTo) {
        window.location.href = redirectTo;
      }
    }
  });

  // Toggle account menu if product type link is touched (hover is not possible on touch devices).
  $('[data-expand-on-enter]').on('keydown', (e) => {
    if (e.key == 'Enter') {
      $(e.currentTarget).dropdown('toggle');
    }
  });

  // Toggle account menu if product type link is touched (hover is not possible on touch devices).
  $('.dropdown').on('show.bs.dropdown', (e) => {
    $(e.currentTarget)
      .find('.dropdown-item')
      .attr('tabindex', 0)
      .attr('aria-hidden', false);
  });
  // Toggle account menu if product type link is touched (hover is not possible on touch devices).
  $('.dropdown').on('hide.bs.dropdown', (e) => {
    $(e.currentTarget)
      .find('.dropdown-item')
      .attr('tabindex', -1)
      .attr('aria-hidden', true);
  });

  // Close hamburger menu when auth section is toggled.
  $('body').on('click', '[data-auth-section-toggle]', (e) => closeNavbar());

  // Hide auth section and hamburger menu on global search button click.
  $('#globalSearchToggle').on('click', () => {
    $('#authSection').removeClass('expand-auth-section');
    closeNavbar();
  });

  // Update products in cart number.
  $(document).on('mvfx:cartRefreshed', (e) => {
    let $counterContainer = $('#cartProductCount');
    let itemCount = e.cartState.item_count;

    if (itemCount > 0) {
      $counterContainer.text(itemCount);
    } else {
      $counterContainer.text('');
    }
  });

  let $collapsibleBtns = $('.navbar [data-toggle="collapse"]');
  let $collapsibles = $('.navbar .collapse');

  // Prevent bug in bootstrap navbar-toggler
  $collapsibles.on('transitionend', (e) => {
    e.stopPropagation();
    return false;
  });

  const stopCollapse = (e) => {
    e.preventDefault();
  };

  let collapsiblesEnabled;

  // Toggle collapsible sections on mobile/desktop
  const toggleCollapsibles = throttle(
    () => {
      let v = window.innerWidth < 640;
      if (v != collapsiblesEnabled) {
        collapsiblesEnabled = v;
        if (!collapsiblesEnabled) {
          $collapsibleBtns.on('click touchstart', stopCollapse); // prevent focus (?) getting stuck in dropdown when the now non-clickable header is being clicked
          $collapsibles
            .css('transition', 'none')
            .collapse('show')
            .css('transition', '');
          $collapsibles.on('show.bs.collapse', stopCollapse);
          $collapsibles.on('hide.bs.collapse', stopCollapse);
        } else {
          $collapsibleBtns.off('click touchstart', stopCollapse);
          $collapsibles.off('show.bs.collapse', stopCollapse);
          $collapsibles.off('hide.bs.collapse', stopCollapse);
          $collapsibles
            .css('transition', 'none')
            .collapse('hide')
            .css('transition', '');
        }
      }
    },
    300,
    { leading: true, trailing: true }
  );

  $(window).on('resize', toggleCollapsibles);
  toggleCollapsibles();
})();
